import { AfterViewInit, Component, Input, OnInit } from '@angular/core'
import { Player } from '../../../core/models/player.model'
import { CommonModule } from '@angular/common'
import { FlagPipe } from "../../../shared/pipes/flag.pipe"
import { AutoscaleTextDirective } from '../../../shared/directives/autoscale-text.directive'

@Component({
  selector: 'player-card',
  standalone: true,
  imports: [
    CommonModule,
    FlagPipe,
    AutoscaleTextDirective
  ],
  templateUrl: './player-card.component.html',
  styleUrls: ['./player-card.component.css']
})
export class PlayerCardComponent implements OnInit{
  @Input() player: Player | null = null
  @Input() flag: boolean = true
  @Input() blue: boolean = false
  
  constructor() {}

  ngOnInit() {}

  
  isBigImage(): boolean {
    return !this.player?.imgUrl?.startsWith('https://images.fotmob')
  }
}
